module.exports = __webpack_public_path__ + "static/media/cards-gradient.61a6c267.png";